export default {
  name: 'timeattend',
  data () {
    return {
      label: 'TIME ATTENDENCE',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/timeattend/script.js